module.exports = __webpack_public_path__ + "static/dl2-stay-human_banner-c035120ef2681637e532fd1c02883a64.jpg";